import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";
import { useContent } from "../contexts/ContentContext";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("diyatour_lang") || "ru");
  const { content } = useContent();

  useEffect(() => {
    localStorage.setItem("diyatour_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // Prefer server-provided content per language, fallback to static translations
  const t =
    (content && content[lang]) ||
    translations[lang] ||
    translations.ru;

  return (
    <I18nContext.Provider value={{ lang, setLang, t, content }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
